import Immutable from 'immutable';
import * as lexical from 'modules/Lexical/helpers';
import { resetInlineStylesOnRelation } from 'modules/Lexical/TextRelationStyles';
import * as Models from 'models';
import { isBrandStyleAvailable } from 'utils/brandStyles';

/**
 * Check whether a style is applied to text component and this style exists in the project
 */
function brandStyleExists(brandStyleId: string, sectionStyles: Immutable.List<string>, brandStyles: Models.BrandStylesMap): boolean {
  return !!brandStyleId && isBrandStyleAvailable(brandStyles, sectionStyles, brandStyleId);
}

export function processBrandStyle(
  textComponent: Models.TextComponent,
  textRelation: Models.RegularRelation<Models.TextRelationStyles>,
  brandStyles: Models.BrandStylesMap,
  sectionStyles: Immutable.List<string>,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList,
  originalTextComponent?: Models.TextComponent | Models.TextComponentMap,
): Models.TextComponent {
  const { styles, styles: { brandStyleId, brandStyleChanged } } = textRelation;
  const styleExists = brandStyleExists(brandStyleId, sectionStyles, brandStyles);
  let updatedTextComponent: Models.TextComponent = textComponent;

  if (originalTextComponent) {
    textRelation.styles = resetInlineStylesOnRelation(styles);
  }

  // TODO: check processing border colors everywhere
  if (styleExists) {
    const brandStyle = brandStyles.get(brandStyleId);
    if (brandStyleChanged) {
      ([
        textRelation.styles,
        updatedTextComponent,
      ] = lexical.matchAppliedStylesWithBrandStyle(textRelation.styles, textComponent, brandStyle, colors, fonts));
    } else {
      updatedTextComponent = lexical.applyBrandStyleOnComponent(textComponent, brandStyle, colors, fonts);
    }
  } else {
    ([textRelation.styles, updatedTextComponent] = lexical.matchAppliedStylesWithDefaultStylesIfPossible(
      textRelation.styles,
      textComponent,
      brandStyles,
      sectionStyles,
      colors,
      fonts,
    ));
  }

  return updatedTextComponent;
}
